module.exports = __webpack_public_path__ + "img/ios_4.ad9f1a0b.png";